import React from 'react';
import '../styles/footer.css';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation('footer');

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-text">
          <p>{t('footer-text-1')}</p>
          <p>{t('footer-text-2')}</p>
          <p>{t('footer-text-3')}</p>
          <address>
            {t('footer-address')}
          </address>
          <p>© 2024 - <a href='https://sistemas.uniandes.edu.co/es/isis' target='_blank' rel="noopener noreferrer" >{t('footer-department')}</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
